<template>
  <v-dialog v-model="visible" width="500" persistent max-width="350">
    <v-form @submit.prevent>
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>
          <p class="body-1">
            {{ text }}
          </p>
          <v-text-field
            solo
            flat
            background-color="grey lighten-3"
            v-model="val"
            :type="options.type"
            @keyup.enter.native="ok"
            autofocus
            :label="options.label"
            :placeholder="options.placeholder"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">Cancelar</v-btn>
          <v-btn
            color="accent darken-1"
            :disabled="options.required && val === ''"
            text
            @click="ok"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "PromptDialogComponent",
  data() {
    return {
      val: "",
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    options: {
      type: Object,
      default: new Object({
        inputType: "text",
      }),
    },
    confirm: {
      typ: Function,
      default: () => {},
    },
    cancel: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.val = "";
      this.cancel();
      this.$destroy();
      removeElement(this.$el);
    },
    async ok() {
      if (this.options.required && this.val === "") return;
      await this.confirm();
      this.visible = false;
      this.$destroy();
      removeElement(this.$el);
    },
  },
  beforeMount() {
    document.querySelector("#app").appendChild(this.$el);
  },
  mounted() {},
};

function removeElement(el) {
  if (typeof el.remove !== "undefined") {
    el.remove();
  } else {
    el.parentNode.removeChild(el);
  }
}
</script>
